<template>
    <div class="header-banner m-0 bg-dark text-white" :style="`min-height: ${(isMobile? '50px' : '36px')}`">
        <template v-if="isMobile">
            <span>Start now to accelerate math success in 2026! <a 
                href="https://info.nextgenmath.com/free-state-framework-sbac-blueprint-training-program" 
                target="_blank" 
                rel="noopener noreferrer"
                class="text-white text-underline">Learn More.</a>
            </span>
        </template>
        <template v-else>
            <span>Start now to accelerate math success in 2026! <strong>Get the free Mastering the Math Blueprint Training Program.</strong> <a 
                href="https://info.nextgenmath.com/free-state-framework-sbac-blueprint-training-program" 
                target="_blank" 
                rel="noopener noreferrer"
                class="text-white text-underline">Learn More.</a>
            </span>
        </template>
    </div>
</template>

<script>
    export default {
        inject: ['isMobile'],
        data: () => ({
            listings: [
                {
                    role: 'Per Diem Professional Development Providers',
                    linkToDescription: '',
                    linkToApplication: 'https://docs.google.com/forms/d/e/1FAIpQLSe0lBxkDJA9KpPt8W1NjuqJLDnBfssGNNFRiHPsPuXVaBNtcw/viewform?usp=sf_link',
                },
                {
                    role: 'Instructional Video Creator',
                    linkToDescription: '',
            linkToApplication: 'https://www.indeed.com/job/mathematics-teacher-6aa5239a15ff9356?_ga=2.80496983.1966785984.1672788846-400955871.1672788846',
                },
            ]
        }),
    }
// const headerNotification = document.getElementById('header-notification');
// const dontShowAgain = document.getElementById('hide-job-notification');
// const isEnabled = headerNotification ? headerNotification.getAttribute('data-enabled') : false;

// if (headerNotification) {
//     dontShowAgain.addEventListener('click', function() {
//         localStorage.setItem('hide_job_notification', true);
//         headerNotification.style.display = 'none';
//     });

//     if (!localStorage.getItem('hide_job_notification') && isEnabled) {
//         headerNotification.style.display = 'block';
//     } else {
//         headerNotification.style.display = 'none';
//     }
// }
</script>

<style lang="scss" scoped>
    .header-banner {
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px;
        width: 100%;
        position: fixed;    
        border-bottom: 1px solid #000;
        text-align: center;
        z-index: 20;
        a.btn {
            color: #000 !important;
            font-weight: 600;
        }

        a.text-underline {
            text-decoration: underline;
        }
    }
</style>
